let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hUMW4"), load("4aLlP"), load("KsAVd"), load("XgRtr")]).then(() => parcelRequire('aQXpZ'));